
export const LOCATIONS = [
  {
    "key": "ARGENTINA",
    "val": "Argentina"
  },
  {
    "key": "ARGENTINA_BUENOS-AIRES",
    "val": "Argentina, Buenos Aires"
  },
  {
    "key": "AUSTRALIA",
    "val": "Australia"
  },
  {
    "key": "AUSTRALIA_BRISBANE",
    "val": "Australia, Brisbane"
  },
  {
    "key": "AUSTRALIA_CANBERRA",
    "val": "Australia, Canberra"
  },
  {
    "key": "AUSTRALIA_MELBOURNE",
    "val": "Australia, Melbourne"
  },
  {
    "key": "AUSTRALIA_PERTH",
    "val": "Australia, Perth"
  },
  {
    "key": "AUSTRALIA_SYDNEY",
    "val": "Australia, Sydney"
  },
  {
    "key": "AUSTRIA",
    "val": "Austria"
  },
  {
    "key": "AUSTRIA_BREGENZ",
    "val": "Austria, Bregenz"
  },
  {
    "key": "AUSTRIA_GRAZ",
    "val": "Austria, Graz"
  },
  {
    "key": "AUSTRIA_INNSBRUCK",
    "val": "Austria, Innsbruck"
  },
  {
    "key": "AUSTRIA_SALZBURG",
    "val": "Austria, Salzburg"
  },
  {
    "key": "AUSTRIA_VIENNA",
    "val": "Austria, Vienna"
  },
  {
    "key": "BANGLADESH",
    "val": "Bangladesh"
  },
  {
    "key": "BANGLADESH_DHAKA",
    "val": "Bangladesh, Dhaka"
  },
  {
    "key": "BELARUS",
    "val": "Belarus"
  },
  {
    "key": "BELGIUM",
    "val": "Belgium"
  },
  {
    "key": "BELGIUM_BRUSSELS",
    "val": "Belgium, Brussels"
  },
  {
    "key": "BRAZIL",
    "val": "Brazil"
  },
  {
    "key": "BRAZIL_BELO-HORIZONTE",
    "val": "Brazil, Belo Horizonte"
  },
  {
    "key": "BRAZIL_RIO-DE-JANEIRO",
    "val": "Brazil, Rio de Janeiro"
  },
  {
    "key": "BRAZIL_SAO-PAULO",
    "val": "Brazil, Sao Paulo"
  },
  {
    "key": "BULGARIA",
    "val": "Bulgaria"
  },
  {
    "key": "BULGARIA_CHIRPAN",
    "val": "Bulgaria, Chirpan"
  },
  {
    "key": "BULGARIA_SOFIA",
    "val": "Bulgaria, Sofia"
  },
  {
    "key": "CANADA",
    "val": "Canada"
  },
  {
    "key": "CANADA_TORONTO",
    "val": "Canada, Toronto"
  },
  {
    "key": "CHILE",
    "val": "Chile"
  },
  {
    "key": "CHILE_SANTIAGO",
    "val": "Chile, Santiago"
  },
  {
    "key": "CHINA",
    "val": "China"
  },
  {
    "key": "CHINA_BEIJING",
    "val": "China, Beijing"
  },
  {
    "key": "CHINA_CHONGQING",
    "val": "China, Chongqing"
  },
  {
    "key": "CHINA_GUANGZHOU",
    "val": "China, Guangzhou"
  },
  {
    "key": "CHINA_HONG-KONG",
    "val": "China, Hong Kong"
  },
  {
    "key": "CHINA_SHANGHAI",
    "val": "China, Shanghai"
  },
  {
    "key": "CHINA_SHENZHEN",
    "val": "China, Shenzhen"
  },
  {
    "key": "CHINA_TIANJIN",
    "val": "China, Tianjin"
  },
  {
    "key": "CHINA_WUHAN",
    "val": "China, Wuhan"
  },
  {
    "key": "COLOMBIA",
    "val": "Colombia"
  },
  {
    "key": "COLOMBIA_BOGOTA",
    "val": "Colombia, Bogota"
  },
  {
    "key": "CROATIA",
    "val": "Croatia"
  },
  {
    "key": "CROATIA_SPLIT",
    "val": "Croatia, Split"
  },
  {
    "key": "CROATIA_ZAGREB",
    "val": "Croatia, Zagreb"
  },
  {
    "key": "CZECH-REPUBLIC",
    "val": "Czech Republic"
  },
  {
    "key": "CZECH-REPUBLIC_PRAGUE",
    "val": "Czech Republic, Prague"
  },
  {
    "key": "DENMARK",
    "val": "Denmark"
  },
  {
    "key": "DENMARK_AALBORG",
    "val": "Denmark, Aalborg"
  },
  {
    "key": "DENMARK_COPENHAGEN",
    "val": "Denmark, Copenhagen"
  },
  {
    "key": "EGYPT",
    "val": "Egypt"
  },
  {
    "key": "EGYPT_CAIRO",
    "val": "Egypt, Cairo"
  },
  {
    "key": "FINLAND",
    "val": "Finland"
  },
  {
    "key": "FINLAND_HELSINKI",
    "val": "Finland, Helsinki"
  },
  {
    "key": "FINLAND_OULU",
    "val": "Finland, Oulu"
  },
  {
    "key": "FRANCE",
    "val": "France"
  },
  {
    "key": "FRANCE_BORDEAUX",
    "val": "France, Bordeaux"
  },
  {
    "key": "FRANCE_BREST",
    "val": "France, Brest"
  },
  {
    "key": "FRANCE_LIMOGES",
    "val": "France, Limoges"
  },
  {
    "key": "FRANCE_LYON",
    "val": "France, Lyon"
  },
  {
    "key": "FRANCE_MARSEILLE",
    "val": "France, Marseille"
  },
  {
    "key": "FRANCE_NANTES",
    "val": "France, Nantes"
  },
  {
    "key": "FRANCE_PARIS",
    "val": "France, Paris"
  },
  {
    "key": "FRANCE_STRASBOURG",
    "val": "France, Strasbourg"
  },
  {
    "key": "FRANCE_TOULOUSE",
    "val": "France, Toulouse"
  },
  {
    "key": "GABON",
    "val": "Gabon"
  },
  {
    "key": "GERMANY",
    "val": "Germany"
  },
  {
    "key": "GERMANY_BERLIN",
    "val": "Germany, Berlin"
  },
  {
    "key": "GERMANY_BREMEN",
    "val": "Germany, Bremen"
  },
  {
    "key": "GERMANY_ESSEN",
    "val": "Germany, Essen"
  },
  {
    "key": "GERMANY_KIEL",
    "val": "Germany, Kiel"
  },
  {
    "key": "GERMANY_LEIPZIG",
    "val": "Germany, Leipzig"
  },
  {
    "key": "GERMANY_MUNICH",
    "val": "Germany, Munich"
  },
  {
    "key": "GHANA",
    "val": "Ghana"
  },
  {
    "key": "GREECE",
    "val": "Greece"
  },
  {
    "key": "GREECE_ATHENS",
    "val": "Greece, Athens"
  },
  {
    "key": "GREECE_SALONNIKI",
    "val": "Greece, Salonniki"
  },
  {
    "key": "HUNGARY",
    "val": "Hungary"
  },
  {
    "key": "HUNGARY_BUDAPEST",
    "val": "Hungary, Budapest"
  },
  {
    "key": "INDIA",
    "val": "India"
  },
  {
    "key": "INDIA_AHMADABAD",
    "val": "India, Ahmadabad"
  },
  {
    "key": "INDIA_BANGALORE",
    "val": "India, Bangalore"
  },
  {
    "key": "INDIA_CALCUTTA",
    "val": "India, Calcutta"
  },
  {
    "key": "INDIA_DELHI",
    "val": "India, Delhi"
  },
  {
    "key": "INDIA_HYDERABAD",
    "val": "India, Hyderabad"
  },
  {
    "key": "INDIA_MADRAS",
    "val": "India, Madras"
  },
  {
    "key": "INDIA_MUMBAI",
    "val": "India, Mumbai"
  },
  {
    "key": "INDONESIA",
    "val": "Indonesia"
  },
  {
    "key": "INDONESIA_JAKARTA",
    "val": "Indonesia, Jakarta"
  },
  {
    "key": "IRAN",
    "val": "Iran"
  },
  {
    "key": "IRAN_TEHRAN",
    "val": "Iran, Tehran"
  },
  {
    "key": "IRAQ",
    "val": "Iraq"
  },
  {
    "key": "IRAQ_BAGHDAD",
    "val": "Iraq, Baghdad"
  },
  {
    "key": "IRELAND",
    "val": "Ireland"
  },
  {
    "key": "IRELAND_DUBLIN",
    "val": "Ireland, Dublin"
  },
  {
    "key": "ISRAEL",
    "val": "Israel"
  },
  {
    "key": "ITALY",
    "val": "Italy"
  },
  {
    "key": "ITALY_BOLZANO",
    "val": "Italy, Bolzano"
  },
  {
    "key": "ITALY_FLORENCE",
    "val": "Italy, Florence"
  },
  {
    "key": "ITALY_MILAN",
    "val": "Italy, Milan"
  },
  {
    "key": "ITALY_NAPLES",
    "val": "Italy, Naples"
  },
  {
    "key": "ITALY_PALERMO",
    "val": "Italy, Palermo"
  },
  {
    "key": "ITALY_ROME",
    "val": "Italy, Rome"
  },
  {
    "key": "JAPAN",
    "val": "Japan"
  },
  {
    "key": "JAPAN_OSAKA",
    "val": "Japan, Osaka"
  },
  {
    "key": "JAPAN_TOKYO",
    "val": "Japan, Tokyo"
  },
  {
    "key": "JORDAN",
    "val": "Jordan"
  },
  {
    "key": "KENYA",
    "val": "Kenya"
  },
  {
    "key": "LATVIA",
    "val": "Latvia"
  },
  {
    "key": "LEBANON",
    "val": "Lebanon"
  },
  {
    "key": "LITHUANIA",
    "val": "Lithuania"
  },
  {
    "key": "MACEDONIA",
    "val": "Macedonia"
  },
  {
    "key": "MADAGASCAR",
    "val": "Madagascar"
  },
  {
    "key": "MALAYSIA",
    "val": "Malaysia"
  },
  {
    "key": "MALI",
    "val": "Mali"
  },
  {
    "key": "MEXICO",
    "val": "Mexico"
  },
  {
    "key": "MEXICO_MEXICO-CITY",
    "val": "Mexico, Mexico City"
  },
  {
    "key": "MOLDOVA",
    "val": "Moldova"
  },
  {
    "key": "MOROCCO",
    "val": "Morocco"
  },
  {
    "key": "MOZAMBIQUE",
    "val": "Mozambique"
  },
  {
    "key": "MYANMAR",
    "val": "Myanmar"
  },
  {
    "key": "NEPAL",
    "val": "Nepal"
  },
  {
    "key": "NETHERLANDS",
    "val": "Netherlands"
  },
  {
    "key": "NETHERLANDS_AMSTERDAM",
    "val": "Netherlands, Amsterdam"
  },
  {
    "key": "NEW-ZEALAND",
    "val": "New Zealand"
  },
  {
    "key": "NICARAGUA",
    "val": "Nicaragua"
  },
  {
    "key": "NIGERIA",
    "val": "Nigeria"
  },
  {
    "key": "NORWAY",
    "val": "Norway"
  },
  {
    "key": "NORWAY_OSLO",
    "val": "Norway, Oslo"
  },
  {
    "key": "OMAN",
    "val": "Oman"
  },
  {
    "key": "PAKISTAN",
    "val": "Pakistan"
  },
  {
    "key": "PAKISTAN_KARACHI",
    "val": "Pakistan, Karachi"
  },
  {
    "key": "PAKISTAN_LAHORE",
    "val": "Pakistan, Lahore"
  },
  {
    "key": "PARAGUAY",
    "val": "Paraguay"
  },
  {
    "key": "PERU",
    "val": "Peru"
  },
  {
    "key": "PERU_LIMA",
    "val": "Peru, Lima"
  },
  {
    "key": "PHILIPPINES",
    "val": "Philippines"
  },
  {
    "key": "PHILIPPINES_MANILA",
    "val": "Philippines, Manila"
  },
  {
    "key": "POLAND",
    "val": "Poland"
  },
  {
    "key": "POLAND_GDANSK",
    "val": "Poland, Gdansk"
  },
  {
    "key": "POLAND_POZNAN",
    "val": "Poland, Poznan"
  },
  {
    "key": "POLAND_WARSAW",
    "val": "Poland, Warsaw"
  },
  {
    "key": "PORTUGAL",
    "val": "Portugal"
  },
  {
    "key": "PORTUGAL_LISBON",
    "val": "Portugal, Lisbon"
  },
  {
    "key": "PORTUGAL_PORTO",
    "val": "Portugal, Porto"
  },
  {
    "key": "ROMANIA",
    "val": "Romania"
  },
  {
    "key": "ROMANIA_BUCAREST",
    "val": "Romania, Bucarest"
  },
  {
    "key": "RUSSIA",
    "val": "Russia"
  },
  {
    "key": "RUSSIA_MOSCOW",
    "val": "Russia, Moscow"
  },
  {
    "key": "RUSSIA_SAINT-PETERSBURG",
    "val": "Russia, Saint Petersburg"
  },
  {
    "key": "SAUDI-ARABIA",
    "val": "Saudi Arabia"
  },
  {
    "key": "SERBIA",
    "val": "Serbia"
  },
  {
    "key": "SLOVAKIA",
    "val": "Slovakia"
  },
  {
    "key": "SLOVENIA",
    "val": "Slovenia"
  },
  {
    "key": "SOUTH-AFRICA",
    "val": "South Africa"
  },
  {
    "key": "SOUTH-KOREA",
    "val": "South Korea"
  },
  {
    "key": "SOUTH-KOREA_SEOUL",
    "val": "South Korea, Seoul"
  },
  {
    "key": "SPAIN",
    "val": "Spain"
  },
  {
    "key": "SPAIN_BARCELONA",
    "val": "Spain, Barcelona"
  },
  {
    "key": "SPAIN_MADRID",
    "val": "Spain, Madrid"
  },
  {
    "key": "SPAIN_SEVILLE",
    "val": "Spain, Seville"
  },
  {
    "key": "SPAIN_VALENCIA",
    "val": "Spain, Valencia"
  },
  {
    "key": "SWEDEN",
    "val": "Sweden"
  },
  {
    "key": "SWEDEN_STOCKHOLM",
    "val": "Sweden, Stockholm"
  },
  {
    "key": "SWITZERLAND",
    "val": "Switzerland"
  },
  {
    "key": "SWITZERLAND_ZURICH",
    "val": "Switzerland, Zurich"
  },
  {
    "key": "SYRIA",
    "val": "Syria"
  },
  {
    "key": "THAILAND",
    "val": "Thailand"
  },
  {
    "key": "THAILAND_BANGKOK",
    "val": "Thailand, Bangkok"
  },
  {
    "key": "TUNISIA",
    "val": "Tunisia"
  },
  {
    "key": "TURKEY",
    "val": "Turkey"
  },
  {
    "key": "TURKEY_ISTANBUL",
    "val": "Turkey, Istanbul"
  },
  {
    "key": "UKRAINE",
    "val": "Ukraine"
  },
  {
    "key": "UNITED-ARAB-EMIRATES",
    "val": "United Arab Emirates"
  },
  {
    "key": "UNITED-KINGDOM",
    "val": "United Kingdom"
  },
  {
    "key": "UNITED-KINGDOM_BELFAST",
    "val": "United Kingdom, Belfast"
  },
  {
    "key": "UNITED-KINGDOM_BIRMINGHAM",
    "val": "United Kingdom, Birmingham"
  },
  {
    "key": "UNITED-KINGDOM_CARDIFF",
    "val": "United Kingdom, Cardiff"
  },
  {
    "key": "UNITED-KINGDOM_EDINBURGH",
    "val": "United Kingdom, Edinburgh"
  },
  {
    "key": "UNITED-KINGDOM_LONDON",
    "val": "United Kingdom, London"
  },
  {
    "key": "UNITED-KINGDOM_MANCHESTER",
    "val": "United Kingdom, Manchester"
  },
  {
    "key": "UNITED-KINGDOM_PLYMOUTH",
    "val": "United Kingdom, Plymouth"
  },
  {
    "key": "UNITED-STATES",
    "val": "United States"
  },
  {
    "key": "UNITED-STATES_ALABAMA",
    "val": "United States, Alabama"
  },
  {
    "key": "UNITED-STATES_ALASKA",
    "val": "United States, Alaska"
  },
  {
    "key": "UNITED-STATES_ARIZONA",
    "val": "United States, Arizona"
  },
  {
    "key": "UNITED-STATES_ARKANSAS",
    "val": "United States, Arkansas"
  },
  {
    "key": "UNITED-STATES_CALIFORNIA",
    "val": "United States, California"
  },
  {
    "key": "UNITED-STATES_CALIFORNIA_LOS-ANGELES",
    "val": "United States, California (LA)"
  },
  {
    "key": "UNITED-STATES_COLORADO",
    "val": "United States, Colorado"
  },
  {
    "key": "UNITED-STATES_CONNECTICUT",
    "val": "United States, Connecticut"
  },
  {
    "key": "UNITED-STATES_DELAWARE",
    "val": "United States, Delaware"
  },
  {
    "key": "UNITED-STATES_FLORIDA",
    "val": "United States, Florida"
  },
  {
    "key": "UNITED-STATES_FLORIDA_MIAMI",
    "val": "United States, Florida (Miami)"
  },
  {
    "key": "UNITED-STATES_GEORGIA",
    "val": "United States, Georgia"
  },
  {
    "key": "UNITED-STATES_HAWAII",
    "val": "United States, Hawaii"
  },
  {
    "key": "UNITED-STATES_IDAHO",
    "val": "United States, Idaho"
  },
  {
    "key": "UNITED-STATES_ILLINOIS",
    "val": "United States, Illinois"
  },
  {
    "key": "UNITED-STATES_ILLINOIS_CHICAGO",
    "val": "United States, Illinois (Chicago)"
  },
  {
    "key": "UNITED-STATES_INDIANA",
    "val": "United States, Indiana"
  },
  {
    "key": "UNITED-STATES_IOWA",
    "val": "United States, Iowa"
  },
  {
    "key": "UNITED-STATES_KANSAS",
    "val": "United States, Kansas"
  },
  {
    "key": "UNITED-STATES_KENTUCKY",
    "val": "United States, Kentucky"
  },
  {
    "key": "UNITED-STATES_LOUISIANA",
    "val": "United States, Louisiana"
  },
  {
    "key": "UNITED-STATES_MAINE",
    "val": "United States, Maine"
  },
  {
    "key": "UNITED-STATES_MARYLAND",
    "val": "United States, Maryland"
  },
  {
    "key": "UNITED-STATES_MASSACHUSETTS",
    "val": "United States, Massachusetts"
  },
  {
    "key": "UNITED-STATES_MICHIGAN",
    "val": "United States, Michigan"
  },
  {
    "key": "UNITED-STATES_MINNESOTA",
    "val": "United States, Minnesota"
  },
  {
    "key": "UNITED-STATES_MISSISSIPPI",
    "val": "United States, Mississippi"
  },
  {
    "key": "UNITED-STATES_MISSOURI",
    "val": "United States, Missouri"
  },
  {
    "key": "UNITED-STATES_MONTANA",
    "val": "United States, Montana"
  },
  {
    "key": "UNITED-STATES_NEBRASKA",
    "val": "United States, Nebraska"
  },
  {
    "key": "UNITED-STATES_NEVADA",
    "val": "United States, Nevada"
  },
  {
    "key": "UNITED-STATES_NEW-HAMPSHIRE",
    "val": "United States, New Hampshire"
  },
  {
    "key": "UNITED-STATES_NEW-JERSEY",
    "val": "United States, New Jersey"
  },
  {
    "key": "UNITED-STATES_NEW-MEXICO",
    "val": "United States, New Mexico"
  },
  {
    "key": "UNITED-STATES_NEW-YORK",
    "val": "United States, New York"
  },
  {
    "key": "UNITED-STATES_NEW-YORK_NEW-YORK-CITY",
    "val": "United States, New York (NY)"
  },
  {
    "key": "UNITED-STATES_NORTH-CAROLINA",
    "val": "United States, North Carolina"
  },
  {
    "key": "UNITED-STATES_NORTH-DAKOTA",
    "val": "United States, North Dakota"
  },
  {
    "key": "UNITED-STATES_OHIO",
    "val": "United States, Ohio"
  },
  {
    "key": "UNITED-STATES_OKLAHOMA",
    "val": "United States, Oklahoma"
  },
  {
    "key": "UNITED-STATES_OREGON",
    "val": "United States, Oregon"
  },
  {
    "key": "UNITED-STATES_PENNSYLVANIA",
    "val": "United States, Pennsylvania"
  },
  {
    "key": "UNITED-STATES_PENNSYLVANIA_PHILADELPHIA",
    "val": "United States, Pennsylvania (PHL)"
  },
  {
    "key": "UNITED-STATES_RHODE-ISLAND",
    "val": "United States, Rhode Island"
  },
  {
    "key": "UNITED-STATES_SOUTH-CAROLINA",
    "val": "United States, South Carolina"
  },
  {
    "key": "UNITED-STATES_SOUTH-DAKOTA",
    "val": "United States, South Dakota"
  },
  {
    "key": "UNITED-STATES_TENNESSEE",
    "val": "United States, Tennessee"
  },
  {
    "key": "UNITED-STATES_TEXAS",
    "val": "United States, Texas"
  },
  {
    "key": "UNITED-STATES_UTAH",
    "val": "United States, Utah"
  },
  {
    "key": "UNITED-STATES_VERMONT",
    "val": "United States, Vermont"
  },
  {
    "key": "UNITED-STATES_VIRGINIA",
    "val": "United States, Virginia"
  },
  {
    "key": "UNITED-STATES_WASHINGTON",
    "val": "United States, Washington"
  },
  {
    "key": "UNITED-STATES_WEST-VIRGINIA",
    "val": "United States, West Virginia"
  },
  {
    "key": "UNITED-STATES_WISCONSIN",
    "val": "United States, Wisconsin"
  },
  {
    "key": "UNITED-STATES_WYOMING",
    "val": "United States, Wyoming"
  },
  {
    "key": "URUGUAY",
    "val": "Uruguay"
  },
  {
    "key": "VIETNAM",
    "val": "Vietnam"
  },
  {
    "key": "VIETNAM_HO-CHI-MINH",
    "val": "Vietnam, Ho Chı Minh"
  },
  {
    "key": "ZAMBIA",
    "val": "Zambia"
  },
  {
    "key": "ZIMBABWE",
    "val": "Zimbabwe"
  }
]